/** HP-23 (c): the hold's end as a clock time ("15:42"), or null. */
export const heldClock = (error) => {
  const detail = error?.response?.data?.detail
  const until = detail && typeof detail === 'object' ? detail.held_until : null
  if (error?.response?.status !== 429 || !until) return null
  const at = new Date(until)
  if (Number.isNaN(at.getTime())) return null
  return at.toLocaleTimeString(i18n.language || 'en', { hour: '2-digit', minute: '2-digit' })
}

// The i18next instance itself (initialised by src/i18n), not src/i18n: tests
// that mock react-i18next import this file through useAuth.
import i18n from 'i18next'

// VH-283: the server answers every refused login (unknown name, wrong
// password, held) with one 401, and a switched-off account with a 403 after
// the right password. The per-address request limit answers 429; it gets the
// same refusal text. All are shown in the user's language, not as the
// server's English detail.
export const loginErrorMessage = (error) => {
  const status = error?.response?.status
  // HP-23 (c): a hold names when to try again, as in the other products.
  const held = heldClock(error)
  if (held) return i18n.t('auth.heldUntil', { until: held })
  if (status === 401 || status === 429) return i18n.t('auth.loginRefused')
  if (status === 403) return i18n.t('auth.accountDeactivated')
  return error?.response?.data?.detail || i18n.t('auth.loginFailed')
}
